import { styled, Switch } from "@mui/material";

interface AntSwitchProps {
  onClick?: (a: any) => void;
  onChange?: (a: any) => void;
  checked?: any;
  inputProps?:any
}

const AntSwitch = ({ onClick, onChange, checked, inputProps, ...props }: AntSwitchProps) => {
  const CustomAntSwitch = styled(Switch)(({ theme }) => ({
    width: 18,
    height: 11,
    padding: 0,
    display: "flex",
    "&:active": {
      "& .MuiSwitch-thumb": {
        width: "5px",
        height: "5px",
      },
    },
    "& .MuiSwitch-switchBase": {
      padding: 2,
      "&.Mui-checked": {
        transform: "translateX(8px)",
        color: "#1F2F34",
        "& + .MuiSwitch-track": {
          opacity: 1,
          backgroundColor: "#17B2EB",
          border: "1.32px solid #17B2EB",
        },
      },
    },
    "& .MuiSwitch-thumb": {
      width: "5px",
      height: "5px",
      margin: "1.3px 1px 0 1px",
      borderRadius: 6,
      boxShadow: "none",
      transition: theme.transitions.create(["width"], {
        duration: 300,
      }),
    },
    "& .MuiSwitch-track": {
      opacity: 1,
      backgroundColor: "transparent",
      boxSizing: "border-box",
      border: "1.32px solid var(--text-text-tertiary, #A5A8A9)",
      borderRadius: 16 / 2,
    },
  }));

  return (
    <>
      <CustomAntSwitch
        checked={checked}
        onChange={onChange}
        onClick={onClick}
        inputProps={inputProps}
        {...props}
      />
    </>
  );
};

export default AntSwitch;
